import {Provider} from '@angular/core';

import {GetConfigUseCasePort} from '@features/app-config/application/use_cases/get-config/get-config.use-case.port';

import {GetConfigUseCase} from '@features/app-config/application/use_cases/get-config/get-config.use-case';
import {AppConfigHttpAdapterProvider} from '@features/app-config/infrastructure/http/app-config.http.adapter.provider';

export const GetConfigUseCaseProvider: Provider[] = [
  AppConfigHttpAdapterProvider,
  {
    provide: GetConfigUseCasePort,
    useClass: GetConfigUseCase
  }
];
